<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from './stores/auth'

const auth = useAuthStore()

onMounted(() => {
  auth.initialize()
})
</script>

<template>
  <v-app>
    <v-overlay v-if="auth.loading" :model-value="true" persistent class="d-flex align-center justify-center">
      <v-progress-circular indeterminate color="primary" size="48" />
    </v-overlay>
    <router-view v-else />
  </v-app>
</template>
